/**
 * Created by Administrator on 2017/3/16.
 */
import { Component } from "@angular/core";
import { StroageService } from "../service/stroage";
//import {RouteConfig, ROUTER_DIRECTIVES} from '@angular/router';
import { Router } from "@angular/router";

@Component({
  selector: "left-menu",
  templateUrl: "./index.html",
})
export class LeftMenu {
  constructor(private stroage: StroageService, private route: Router) {}
  private roles: any = "";
  public checkRole(role): boolean {
    try {
      this.roles = this.stroage.getStroage("roles").split(",");
      for (let i = 0; i < this.roles.length; i++) {
        if (this.roles[i] == role) {
          return true;
        }
      }
      return false;
    } catch (e) {
      this.route.navigate(["/login"]);
    }
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/left-menu/leftMenu.component.ts